import { CategorieCritereEnum } from './enums/categorie-critere.enum';
import { TypeAvisEnum } from './enums/type-avis.enum';

export class TypeAvis {

    public code: TypeAvisEnum;
    public libelle: String;
    public categorie: string = CategorieCritereEnum[CategorieCritereEnum.CATAGORIE_4];

}
